__turbopack_context__.v({
  "body": "uz8gEG_body",
  "subtitle": "uz8gEG_subtitle",
  "title": "uz8gEG_title",
});
